export default __webpack_public_path__ + "static/media/pics-contact-cgk.8bcf5452.jpg";